import {paginationMixin} from "@/domain/galleries/mixins";

const state = {
    photos: [],
    pagination: paginationMixin()
}

const getters = {
    photos: state => state.photos,
    pagination: state => state.pagination
}

const mutations = {
    setPhotos(state, {photos}) {
        if (state.photos.length > 0) {
            state.photos = state.photos.concat(photos)
        } else {
            state.photos = photos
        }
    },
    resetPagination(state) {
        state.photos = []
        state.pagination = paginationMixin()
    },
    setPagination(state, pagination) {
        state.pagination = pagination
    }
}

export const actions = (mediaService) => ({
    async fetchPhotos(context, {checkin_id, params}) {
        const response = await mediaService.getAllMedias(checkin_id, params)
        context.commit('setPhotos', {
            photos: response.results
        })
        context.commit('setPagination', response.pagination)
        return response.results
    }
}
)

export default mediaService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(mediaService)
})